export const API_KEY_PREFIX = "3b_sk_";

// Name prefix marking a member-modal user API key (createUserApiKey). Lets the
// deprecated api-keys settings page filter these out — so creating one doesn't
// resurrect that page — while the member modal strips it for display.
export const USER_API_KEY_NAME_PREFIX = "userkey:";

// Name prefix marking a credential minted by the federated-token exchange (the
// suffix is the service_account_federations id). Shared by the mint site and
// the queries that hide these auto-minted keys, so the two can't drift.
export const FEDERATED_API_KEY_NAME_PREFIX = "federated:";
